export const moneyToNumber = (value) => {
  return Math.abs(Number(String(value || "").replace(/[^0-9.-]+/g, "")) || 0);
};

export const getTodayDateString = () => {
  return new Date().toISOString().split("T")[0];
};

export const buildAdviserOptions = (advisers = []) => {
  return advisers
    .filter((adviser) => adviser.email)
    .map((adviser) => {
      const firstName = adviser.preferredName || adviser.firstName || "";
      const lastName = adviser.lastName || adviser.surname || "";
      const name = `${firstName} ${lastName}`.trim() || adviser.email;

      return {
        id: adviser.email,
        value: adviser.email,
        name,
        label: name,
        email: adviser.email,
      };
    });
};

export const buildCaseTypeOptions = (selectedCatalog) => {
  if (!selectedCatalog?.categories?.length) {
    return [];
  }

  return selectedCatalog.categories.flatMap((category) => {
    return (category.items || [])
      .filter((item) => item.visibleOnFrontend !== false)
      .filter((item) => item.isActive !== false)
      .map((item) => {
        const optionId = `${category.id}__${item.id}`;

        return {
          id: optionId,
          value: optionId,
          name: item.name || item.id,
          label: `${item.name} - ${category.name}` || item.id,

          categoryId: category.id,
          categoryName: category.name || category.id,

          itemId: item.id,
          item,
          category,
        };
      });
  });
};

export const buildAdditionalChargeOptions = (selectedItem) => {
  const catalogueOptions = (selectedItem?.modifiers || [])
    .filter((modifier) => modifier.isActive !== false)
    .map((modifier) => ({
      id: modifier.id,
      value: modifier.id,
      name: modifier.label || modifier.name || modifier.id,
      label: modifier.label || modifier.name || modifier.id,
      amount: moneyToNumber(modifier.amount),
      type: "charge",
      isDiscount: false,
      isCustomOption: false,
      modifier,
    }));

  return [
    {
      id: "custom_charge",
      value: "custom_charge",
      name: "Custom Charge",
      label: "Custom Charge",
      amount: 0,
      type: "custom",
      isDiscount: false,
      isCustomOption: true,
    },
    {
      id: "discount",
      value: "discount",
      name: "Discount",
      label: "Discount",
      amount: 0,
      type: "discount",
      isDiscount: true,
      isCustomOption: true,
    },
    ...catalogueOptions,
  ];
};

export const getSelectedTaskLabels = (
  selectedTaskValues = [],
  taskOptions = [],
) => {
  return taskOptions
    .filter((task) => selectedTaskValues.includes(task.value))
    .map((task) => task.label);
};

export const createCustomChargeId = (label) => {
  return `custom_${Date.now()}_${String(label || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")}`;
};

export const getInitialAddCaseFormData = ({
  defaultType,
  loggedInParaplannerName,
  loggedInEmail,
}) => {
  return {
    catalogId: defaultType || "financial_planning",

    categoryId: "",
    itemId: "",

    startDate: getTodayDateString(),
    completionDate: getTodayDateString(),

    adviserName: "",
    adviserEmail: "",

    clientFirstName: "",
    clientLastName: "",

    clients: [],

    assignedToName: loggedInParaplannerName || "",
    assignedToEmail: loggedInEmail || "",

    status: "in_progress",

    baseChargeOverride: "",

    additionalChargeLabel: "",
    additionalChargeAmount: "",
    additionalChargeCatalogId: "",
    additionalChargeType: "",
    additionalChargeIsDiscount: false,
    additionalChargeQuantity: 1,

    selectedModifiers: [],

    tasksForCase: [],
    notes: "",
  };
};

export const buildAssignedToOptions = (assignedToList = []) => {
  return assignedToList.map((person) => ({
    id: person.email,
    value: person.email,
    name: person.label || person.name || person.email,
    label: person.label || person.name || person.email,
    email: person.email,
  }));
};
